export default {
    templateCenter: {
        searchTemplate: '搜索模板',
        allTemplate: '全部模板',
        workflow: '工作流',
        embedding: '知识应用',
        lightApp: '轻量应用',
        Agent: '智能体',
        recentUpdate: '最近更新',
        resourceRequiredTip: '所需资源：',
        templateContains: '模板包含',
        templateContainsTip: '功能，需升级后复制',
        seeTemplateDescription: '详见模板说明',
        copy: '复制',
        duplicate: '复制',
        templateCopy: '模板复制',
        templateCopyTip: '复制后会为您直接创建一个相同的应用或工作流，模板中包含的资源会占用应用、工作流、自定义插件、知识库、数据库的容量(如有)，请确保容量足够。',
        templateCopyTip2: '模板中的设定和数据仅作为示例，复制后可根据实际需求进行调整或删除。',
        resourceRequired: '所需资源',
        appTip: '应用：',
        databaseTip: '数据库：',
        rowCount: '行数：',
        resourceNotEnough: '资源不足',
        knowledgeBaseTip: '知识库：',
        customPluginTip: '自定义插件：',
        workflowTip: '工作流：',
        goUpgrade: '前往升级',
        app: '应用',
        database: '数据库',
        customPlugin: '自定义插件',
        knowledgeBase: '知识库',
        copySuccess: '复制成功',
        resourceContains: '包含资源：',
        experienceNow: '立即体验',
    }
}